import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
    selector: 'app-user-vacancy-form',
    templateUrl: './user-vacancy-form.component.html',
    styleUrls: ['./user-vacancy-form.component.scss']
})
export class UserVacancyFormComponent implements OnInit {
    mode: string = 'add'; // 'add' | 'edit'
    isSaving: boolean = false;
    users: any[] = [];
    designations: any[] = []; // roles list (multi-select source)
    // Fixed dropdown, not free text — a typo here ("UP" vs "Uttar Pradesh" vs
    // "up") used to split one state into several buckets on the Board filter
    // and the Dashboard state map. One canonical spelling per state fixes that.
    indianStates: string[] = [
        'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa',
        'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala',
        'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland',
        'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
        'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
        'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
        'Delhi NCR', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
    ];
    ownerAuto: boolean = false; // true jab owner assigned-user se auto-fill hua ho
    private parentOf: { [id: string]: any } = {}; // asm_id -> rsm_id (direct senior)

    form: any = {
        id: '',
        station_name: '',
        state_name: '',
        designation_ids: [], // multiple designation (role) ids
        owner_id: '',
        assigned_user_id: '',
        status: 'OPEN',
        replacement_needed: false,
        remarks: ''
    };

    constructor(
        public dialogRef: MatDialogRef<UserVacancyFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public serve: DatabaseService,
        public toast: ToastrManager
    ) {}

    ngOnInit() {
        this.mode = this.data.mode || 'add';
        this.loadUsers();
        this.loadDesignations();

        if (this.mode === 'edit' && this.data.station) {
            const s = this.data.station;
            this.form = {
                id: s.id,
                station_name: s.station_name || '',
                state_name: s.state_name || '',
                // comma-separated ids ("5,8") -> array of string ids for mat-select pre-select
                designation_ids: s.designation_id
                    ? String(s.designation_id).split(',').map((x: string) => x.trim()).filter((x: string) => x)
                    : [],
                owner_id: s.owner_id || '',
                assigned_user_id: s.assigned_user_id || '',
                status: s.status || (s.assigned_user_id ? 'CLOSED' : 'OPEN'),
                replacement_needed: (s.replacement_needed == 1 || s.replacement_needed === true),
                remarks: s.remarks || ''
            };

            // Existing row might carry an old free-text value ("UP", "Delhi")
            // from before this was a dropdown — keep it selectable rather than
            // silently blanking their state out the moment they open Edit.
            if (this.form.state_name && this.indianStates.indexOf(this.form.state_name) === -1) {
                this.indianStates = [this.form.state_name, ...this.indianStates];
            }
        }
    }

    loadDesignations() {
        this.serve.post_rqst({ search: '' }, 'Master/designationList').subscribe((result: any) => {
            if (result['statusCode'] == 200) {
                this.designations = result['data'] || [];
            }
        });
    }

    loadUsers() {
        this.serve.post_rqst({}, 'Master/baseStationUserList').subscribe((result: any) => {
            if (result['statusCode'] == 200) {
                this.users = result['result'] || [];
                const assignments: any[] = result['assignments'] || [];
                this.parentOf = {};
                for (const a of assignments) {
                    this.parentOf[a.asm_id] = a.rsm_id; // junior -> direct senior
                }
            }
        });
    }

    // Assigned user badalne par owner auto-fill + status sync
    onAssignedChange() {
        // status: assigned user hai -> Filled (CLOSED), warna Vacant (OPEN)
        this.form.status = this.form.assigned_user_id ? 'CLOSED' : 'OPEN';

        if (this.form.assigned_user_id) {
            const seniorId = this.parentOf[this.form.assigned_user_id];
            if (seniorId) {
                this.form.owner_id = seniorId;
                this.ownerAuto = true;
                return;
            }
        }
        // vacant ya senior nahi mila -> owner manual chunne do
        this.ownerAuto = false;
    }

    save() {
        if (!this.form.station_name) {
            this.toast.warningToastr('Station name is required.');
            return;
        }
        if (!this.form.owner_id) {
            this.toast.warningToastr('Owner (senior) is required. Select an assigned user or choose an owner manually.');
            return;
        }

        this.isSaving = true;
        const endpoint = this.mode === 'add' ? 'Master/baseStationMasterAdd' : 'Master/baseStationMasterEdit';

        this.serve.post_rqst({ data: this.form }, endpoint).subscribe((result: any) => {
            this.isSaving = false;
            if (result['statusCode'] == 200) {
                this.toast.successToastr(this.mode === 'add' ? 'Base station added.' : 'Base station updated.');
                this.dialogRef.close('saved');
            } else {
                this.toast.errorToastr(result['message'] || 'Failed to save.');
            }
        }, () => {
            this.isSaving = false;
            this.toast.errorToastr('Network error.');
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}
